import { bytesToHex } from "../utils";
export function createNodeId(bytes) {
    if (bytes.length !== 32) {
        throw new Error("NodeId must be 32 bytes in length");
    }
    return bytesToHex(bytes);
}
//# sourceMappingURL=create.js.map